import { Cardable, MinidocToolbarAction } from 'minidoc-editor/dist/types';
import { Minidoc } from 'client/lib/minidoc';
import { showVimeoModal } from './vimeo-modal';

export { parseVimeoUrl } from 'shared/media';

export function buildVimeoEmbed(videoId: string, hash?: string): string {
  const hashParam = hash ? `?h=${hash}` : '';
  return `<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/${videoId}${hashParam}" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>`;
}

export const vimeoToolbarAction: MinidocToolbarAction = {
  id: 'vimeo',
  label: 'Insert Vimeo Video',
  html: `<svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M23.977 6.416c-.105 2.338-1.739 5.543-4.894 9.609C15.906 20.028 12.98 22 10.56 22c-1.5 0-2.77-1.384-3.81-4.155l-2.08-7.637C3.88 7.436 3.06 6.052 2.18 6.052c-.19 0-.855.4-1.996 1.193L-.001 5.6a316 316 0 0 0 3.692-3.292C5.367.928 6.65.2 7.563.12c1.83-.176 2.957 1.076 3.381 3.76.458 2.9.775 4.7.953 5.403.53 2.407 1.112 3.61 1.748 3.61.493 0 1.235-.78 2.223-2.34.989-1.56 1.519-2.748 1.588-3.566.14-1.353-.39-2.03-1.593-2.03-.567 0-1.152.13-1.755.388 1.166-3.819 3.394-5.676 6.687-5.572 2.44.07 3.59 1.655 3.182 4.663z"/></svg>`,
  async run(t) {
    const editor = t as unknown as Minidoc & Cardable;
    const range = document.getSelection()?.getRangeAt(0).cloneRange();
    const props = await showVimeoModal();
    if (props) {
      document.getSelection()?.removeAllRanges();
      document.getSelection()?.addRange(range!);
      editor.insertCard('embed', props);
    }
  },
};
